import {
  pathOr
} from 'ramda'

const getTargetValue = pathOr('', ['target', 'value'])

export default getTargetValue